var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007BFF",
    d: "M0 0H64V64H0z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M38.75 7.579h-17.5c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h13.858l-7.68 5.972-5.508-3.502-1.34 2.11 6.25 3.975c.203.13.438.195.67.195.27 0 .543-.088.767-.263l9.233-7.182v16.195H21.25c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h17.5c.69 0 1.25-.56 1.25-1.25v-20c0-.69-.56-1.25-1.25-1.25z",
    transform: "translate(12 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M22.047.366C21.762.13 21.38.026 21.02.101l-20 3.75C.427 3.961 0 4.476 0 5.08v27.5c0 .6.427 1.117 1.02 1.227l20 3.75c.075.015.152.023.23.023.29 0 .573-.1.797-.288.288-.237.453-.592.453-.962v-35c0-.373-.165-.725-.453-.963z",
    transform: "translate(12 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M11.25 27.579c-3.445 0-6.25-3.365-6.25-7.5s2.805-7.5 6.25-7.5 6.25 3.365 6.25 7.5-2.805 7.5-6.25 7.5zm0-12.5c-2.068 0-3.75 2.242-3.75 5 0 2.757 1.682 5 3.75 5s3.75-2.243 3.75-5c0-2.758-1.682-5-3.75-5z",
    transform: "translate(12 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.00b7100907ab9bfadb18dba21b368246.svg";
export { ForwardRef as ReactComponent };